export default  {	
	data () {
		return { 
			active: 0,
			uploadReady: true,
			searchsGet: null,
			filter: {
				id_datos_afiliado: null
			},
		}
	},
	destroyed()
	{
		this.resetCrud({state:'searchSw'})
	}
}
